import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import AIPanel from './AIPanel';

export default function Shell() {
  return (
    <div className="flex h-screen w-full bg-slate-100 overflow-hidden font-sans">
      <Sidebar />
      <div className="flex-1 flex flex-col h-full overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-x-hidden overflow-y-auto w-full relative flex">
          <div className="flex-1 h-full">
            <Outlet />
          </div>
          <AIPanel />
        </main>
      </div>
    </div>
  );
}